import PropTypes from 'prop-types';

export const Part = {
  id: PropTypes.number,
  shipId: PropTypes.number,
  partnumber: PropTypes.string,
  description: PropTypes.string,
  noOfBoxes: PropTypes.string,
  qtyperBox: PropTypes.string,
  noOfPallets: PropTypes.string,
  plannedShipQty: PropTypes.string,
  isDeleted: PropTypes.string,
  poNumber: PropTypes.string,
};

export const Parts = PropTypes.arrayOf(PropTypes.shape(Part));
